// RichTextEditorField.jsx
import { useEffect, useRef } from "react";

const RichTextEditorField = ({ value, onChange, extraClass }) => {
  const refdiv = useRef(null);

  useEffect(() => {
    if (!window.RichTextEditor || !refdiv.current) return;

    const rte = new window.RichTextEditor(refdiv.current);
    rte.setHTMLCode(value);

    rte.attachEvent("change", () => {
      const content = rte.getHTMLCode();
      onChange(content); // notify Formik
    });

    return () => {
      // Optional: cleanup
    };
  }, [refdiv]);

  return (
    <div className={`richTextEditorMonaco ${extraClass}`}>
      <div ref={refdiv}></div>
    </div>
  );
};

export default RichTextEditorField;
